<template>
  <div>
    <div class="relative w-full header">
      <div class="header-title"></div>
      <div
        class="absolute text-3xl font-bold text-center text-white"
        :style="{
          width: '1200px',
          bottom: '100px',
          left: 'calc(50vw - 600px)',
        }"
      >
        {{ info.name }}
      </div>
    </div>
    <div class="bg-white">
      <div class="max-w-screen-xl pt-4 m-auto">
        <div v-html="info.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { news } from '@/api/news';
export default {
  data() {
    return {
      info: {},
    };
  },
  activated() {
    this.getNews(this.$route.params.id);
  },
  methods: {
    async getNews(id) {
      this.info = await news(id);
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  height: 400px;
  background-image: url(https://yldb.oss-cn-hangzhou.aliyuncs.com/static/default/2022-08-12/a62b9580-c945-4f2b-837f-d51bb38aa105.jpg);
  background-clip: padding-box;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: center center;
  background-blend-mode: normal;
  .header-title {
    height: 400px;
    background-image: linear-gradient(#ffffff, blue);
    opacity: 0.4;
    width: 100%;
  }
}
</style>
